import { MouseEvent } from 'react';

import { GridFields, InfoCard, InfoCardField } from 'components';
import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

export interface RepresentativeData {
  name: string;
  fields: InfoCardField[];
}

interface RepresentativeSectionProps {
  onClickRepresentative?: (event: MouseEvent<HTMLElement>) => void;
  representativeData: RepresentativeData;
}

export const RepresentativeSection = ({
  onClickRepresentative,
  representativeData,
}: RepresentativeSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="representativeSection"
      title={t('client.client.representative.title')}
    >
      <GridFields>
        <InfoCard
          fields={representativeData.fields}
          title={representativeData.name}
          onClick={onClickRepresentative}
        />
      </GridFields>
    </Section>
  );
};
